import CustomIconGardener from 'scoreboard/components/custom-icon-gardener'

var StrategyMapsGardener = CustomIconGardener.extend({
	getIcon(node) {
		return node.type === 'dashboard' ? 'strategy-map' : node.type
	}
})

export default StrategyMapsGardener

StrategyMapsGardener.__filename__ = 'strategy-maps/strategy-maps-gardener.js'
